<template>
  <b-modal class="flow-modal" :can-cancel="true" :has-modal-card="true" scroll="clip" v-model="isModalActive">
    <header class="modal-card-head">
      <div class="logo-container">
        <img :src="`${clientResourcesUrl}logo.png?alt=media`" alt="App Logo" class="app-logo">
      </div>
      <p :class="['modal-card-title','has-text-centered', $mq]">Help</p>
      <button
        type="button"
        class="delete"
        @click="close"/>
    </header>
    <div class="modal-card intro-tips" width="100px">
      <Tutorial
        :show-controls="true"
        :show-prev="false"
        :prev-route="null"
        next-button-label="Next Tip"
        all-videos-viewed-action="event"
        @all-videos-viewed="close"
      />
    </div>
  </b-modal>
</template>

<style>
  .flow-modal .modal-card-head {
    position: relative;
  }

  .flow-modal .app-logo {
    width: 100px;

    position: absolute;
    top: 0;
    left: 0;
    padding: 20px 0 0 20px;
  }

  .app-name {
    font-size: 1.2em;
  }

  .flow-modal .modal-card-title {
    text-align: center;
    font-size: 1.3em;
    font-weight: bold;
  }

  .flow-modal .modal-card-title.sm {
    padding-left: 3.8em;
  }
</style>

<script>
import { ref, watch, toRef } from 'vue'
import { useMainStore } from '@/stores/main'
import { useConfig } from '@/composables/useConfig'
import Tutorial from './lead_workflow_components/Tutorial.vue'

export default {
  name: 'TutorialModal',
  components: {
    Tutorial
  },
  setup() {
    const mainStore = useMainStore()
    const { clientResourcesUrl } = useConfig()
    const isModalActive = ref(false)

    const tutorialModalVisible = toRef(mainStore, 'tutorialModalVisible')

    const setTutorialModalVisibility = (val) => {
      mainStore.setTutorialModalVisibility(val)
    }

    const close = () => {
      setTutorialModalVisibility(false)
    }

    watch(isModalActive, (val) => {
      setTutorialModalVisibility(val)
    })

    watch(tutorialModalVisible, (val) => {
      isModalActive.value = val
    })

    return {
      isModalActive,
      clientResourcesUrl,
      close
    }
  }
}
</script>
